<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useInfoStore } from '@/stores/counter.js'
import { GetUserInfoAPI, getReqData } from '@/util/api'
import encipher from '@/util/mySEC'

const router = useRouter()
const route = useRoute()
const userStore = useInfoStore()
const userInfo = computed(() => userStore.userInfo)

const showUserMenu = ref(false)

const emit = defineEmits(['login'])

const goLogin = () => {
  userStore.setShowLoginModal(true)
}

const toggleUserMenu = () => {
  showUserMenu.value = !showUserMenu.value
}

const getUserInfo = () => {
  if (!userInfo.value) return
  let reqData = {
    uname: userInfo.value.uname,
    uid: userInfo.value.uid,
    token: userInfo.value.token
  }
  reqData = Object.assign(JSON.parse(localStorage.getItem('href-url') || '{}'), reqData)
  GetUserInfoAPI(getReqData(reqData))
    .then((res) => {
      if (res.data.state == 1) {
        userStore.setUserInfo(Object.assign({}, userInfo.value, res.data.data))
        localStorage.setItem(
          'nsjkdjc==',
          encipher.des_encrypt(Object.assign({}, userInfo.value, res.data.data))
        )
      }
    })
    .catch((err) => {
      console.log('[error]', err)
    })
}

const handleMouseEnter = () => {
  showUserMenu.value = true
  getUserInfo()
}

const getVipImage = (level) => {
  level = Number(level) || 0
  return new URL(`../../assets/img/web_home/弹窗切图/VIP${level}@2x.png`, import.meta.url).href
}

onMounted(() => {
  getUserInfo()
})
</script>

<template>
  <div class="desktop-header">
    <div class="header-inner">
      <img src="@/assets/img/web_home/LOGO@2x.png" class="logo" />
      <nav class="nav-links">
        <img
          v-if="route.path === '/'"
          src="@/assets/img/web_home/-h-home-选中.png"
          class="nav-btn"
        />
        <img
          v-else
          src="@/assets/img/web_home/-h-home.png"
          class="nav-btn"
          @click="router.push('/')"
        />

        <img
          v-if="route.path === '/channel'"
          src="@/assets/img/web_home/-h-INFO-选中.png"
          class="nav-btn"
        />
        <img
          v-else
          src="@/assets/img/web_home/-h-INFO.png"
          class="nav-btn"
          @click="router.push('/channel')"
        />

        <img
          v-if="route.path === '/points_shop_page'"
          src="@/assets/img/web_home/-h-Points Store-选中.png"
          class="nav-btn"
        />
        <img
          v-else
          src="@/assets/img/web_home/-h-Points-Store.png"
          class="nav-btn"
          @click="router.push('/points_shop_page')"
        />

        <img
          v-if="route.path === '/pay'"
          src="@/assets/img/web_home/-h-Top-Up-选中.png"
          class="nav-btn"
        />
        <img
          v-else
          src="@/assets/img/web_home/-h-Top-Up.png"
          class="nav-btn"
          @click="router.push('/pay')"
        />

        <img
          v-if="route.path === '/info'"
          src="@/assets/img/web_home/-h-User Centre-选中.png"
          class="nav-btn"
        />
        <img
          v-else
          src="@/assets/img/web_home/-h-User-Centre.png"
          class="nav-btn"
          @click="router.push('/info')"
        />

        <img
          v-if="!userInfo"
          src="@/assets/img/web_home/-h-Login.png"
          class="nav-btn login-btn"
          @click="goLogin"
        />

        <!-- User Info Menu -->
        <div
          v-if="userInfo"
          class="user-info-dropdown"
          @mouseenter="handleMouseEnter"
          @mouseleave="showUserMenu = false"
        >
          <div class="user-info-trigger" @click="router.push('/info')">
            <div class="trigger-avatar-wrapper">
              <img
                src="@/assets/img/web_home/弹窗切图/右上角小头像白底.png"
                class="trigger-avatar-bg"
              />
              <img :src="userInfo.headimg" class="trigger-avatar" v-if="userInfo.headimg" />
              <img
                :src="userInfo.headframe"
                class="trigger-avatar-frame"
                v-if="userInfo.headframe"
              />
            </div>
            <span class="trigger-name">{{ userInfo.rname || userInfo.uname }}</span>
            <img src="@/assets/img/web_home/弹窗切图/向下icon@2x.png" class="trigger-arrow" />
          </div>

          <div class="user-info-popover" v-show="showUserMenu">
            <img src="@/assets/img/web_home/弹窗切图/-h-个人信息弹窗.png" class="popover-bg" />
            <div class="popover-content">
              <div class="popover-top">
                <div class="popover-avatar-wrapper" :class="{ 'has-avatar-frame': !!userInfo.headframe }">
                  <img :src="userInfo.headimg" class="popover-avatar" v-if="userInfo.headimg" />
                  <img
                    :src="userInfo.headframe"
                    class="popover-avatar-frame"
                    v-if="userInfo.headframe"
                  />
                  <div
                    class="popover-avatar-edit-icon"
                    @click="router.push({ path: '/info', query: { edit: 'avatar' } })"
                  >
                    <img src="@/assets/img/web_user/头像编辑（合并）@2x.png" alt="Edit" />
                  </div>
                </div>
                <div class="popover-details">
                  <div class="popover-name-row">
                    <span class="popover-name">{{ userInfo.rname || userInfo.uname }}</span>
                    <img
                      src="@/assets/img/web_home/弹窗切图/姓名编辑@2x.png"
                      class="popover-edit-icon"
                      @click="router.push('/info')"
                    />
                  </div>
                  <div class="popover-tags">
                    <div class="vip-tag-box" v-if="userInfo.viplevel !== undefined">
                      <img :src="getVipImage(userInfo.viplevel)" class="vip-badge-img" />
                    </div>
                    <img
                      :src="userInfo.title"
                      class="popover-user-title-img"
                      v-if="userInfo.title"
                    />
                  </div>
                </div>
              </div>
              <div class="popover-exp">
                <div class="exp-bar-wrapper">
                  <img src="@/assets/img/web_home/弹窗切图/能量条bg@2x.png" class="exp-bar-bg" />
                  <div
                    class="exp-bar-inner-container"
                    :style="{
                      width:
                        Math.min(
                          ((userInfo.vipNowExe || 0) / (userInfo.vipMaxExe || 1)) * 100,
                          100
                        ) + '%'
                    }"
                  >
                    <img
                      src="@/assets/img/web_home/弹窗切图/能量条内部@2x.png"
                      class="exp-bar-inner"
                    />
                  </div>
                </div>
                <div class="exp-text">
                  {{ userInfo.vipNowExe || 0 }}/{{ userInfo.vipMaxExe || 10000 }}EXP
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<style scoped>
.desktop-header {
  width: 100%;
  background: url('@/assets/img/web_home/导航栏bg@2x.png') no-repeat center center;
  background-size: cover;
  height: 100px;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.header-inner {
  width: 75%;
  max-width: 1400px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}

.logo {
  height: 80px;
  width: auto;
}

.nav-links {
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-left: 2vw;
  margin-right: 10vw;
  align-items: center;
  height: 100%;
}

.login-btn {
  margin-left: 100px;
}

.nav-btn {
  height: 60px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s;
}

.nav-btn:hover {
  transform: scale(1.05);
}

/* User Info Dropdown Styles */
.user-info-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 70px;
  height: 100%;
  cursor: pointer;
  padding: 0 10px;
}

.user-info-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 100%;
  width: 100%;
}

.trigger-avatar-wrapper {
  position: relative;
  width: 46px;
  height: 46px;
}

.trigger-avatar-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.trigger-avatar {
  width: 85%;
  height: 85%;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  object-fit: cover;
}

.trigger-avatar-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
  object-fit: contain;
}

.trigger-name {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trigger-arrow {
  width: 12px;
  height: auto;
  transition: transform 0.3s;
}

.user-info-dropdown:hover .trigger-arrow {
  transform: rotate(180deg);
}

.user-info-popover {
  position: absolute;
  top: 100px;
  right: -20px;
  width: 320px;
  z-index: 101;
}

.popover-bg {
  width: 100%;
  height: auto;
  display: block;
}

.popover-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 10px 25px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.popover-top {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 5px;
}

.popover-avatar-wrapper {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  position: relative;
  flex: 0 0 65px;
}

.popover-avatar {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 1;
}

.popover-avatar-wrapper:not(.has-avatar-frame) .popover-avatar {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 0 2px #a6a1f8;
}

.popover-avatar-frame {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
  object-fit: contain;
}

.popover-avatar-edit-icon {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  z-index: 10;
}

.popover-avatar-edit-icon img {
  width: 100%;
  height: 100%;
}

.popover-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.popover-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.popover-name {
  font-size: 18px;
  font-weight: 900;
  color: #333;
}

.popover-edit-icon {
  width: 16px;
  cursor: pointer;
}

.popover-tags {
  display: flex;
  align-items: center;
  gap: 5px;
}

.vip-badge-img {
  height: 24px;
  width: auto;
}

.popover-user-title-img {
  height: 48px;
  width: auto;
  object-fit: contain;
}

.popover-exp {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.exp-bar-wrapper {
  position: relative;
  width: 100%;
  height: 16px;
}

.exp-bar-bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.exp-bar-inner-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
}

.exp-bar-inner {
  height: 100%;
  width: auto;
  min-width: 270px; /* Force original width to prevent squishing */
}

.exp-text {
  font-size: 12px;
  color: #666;
  margin-left: 5px;
  font-weight: bold;
}
</style>
